import {Component, Input} from '@angular/core';
import {IndicatorsViewModel} from './indicators-view.model';

@Component({
  selector: 'app-indicators-view',
  templateUrl: './indicators-view.component.html',
  styleUrls: ['./indicators-view.component.scss']
})
export class IndicatorsViewComponent {
  @Input() indicators: Array<IndicatorsViewModel>;

  constructor() {
  }
}
